import { Network } from '@yme/services/network';
import { SearchSortingValues } from '@yme/utils/bloomreach/constants';
import { DigitalDataMutation, isInsideGenericClickEvent, setDigitalData } from '@yme/utils/common';
const cacheKeyFromParams = (params) => {
    return JSON.stringify(params);
};
const cache = new Map();
const cacheTimeout = 1000 * 60 * 5; // 5 minutes
const setCacheTimeout = (key, timeout = cacheTimeout) => {
    // clear previous timeout
    setTimeout(() => {
        cache.delete(key);
    }, timeout);
};
export async function getFilteredProductsBloomreach({ endpoint, config: { _br_uid_2, account_id, ref_url, request_type, search_type, url, domain_key, fl, start, rows, q, fq, sort, categoryId, accessoryTypeTranslations = [], accessoryUsageTranslations = [], genderTranslations = [], subcategoryTranslations = [], analyticsFacets, }, }) {
    const params = {
        _br_uid_2,
        account_id,
        ref_url,
        request_type,
        search_type,
        url,
        domain_key,
        start,
        rows,
        fl,
        q,
        fq: fq || null,
        sort: SearchSortingValues.SORT_DEFAULT !== sort ? sort : null,
    };
    const cacheParams = {
        start,
        rows,
        q,
        fq,
        sort,
    };
    const shouldReportAnalytics = isInsideGenericClickEvent();
    const cacheKey = cacheKeyFromParams(cacheParams);
    const cachedResult = cache.get(cacheKey);
    if (cachedResult) {
        if (shouldReportAnalytics) {
            setDigitalData(DigitalDataMutation.PLP_VIEW_FILTER_RESULT_BLOOMREACH, {
                searchTerm: categoryId !== q ? q : '',
                facets: analyticsFacets,
                sort,
                accessoryTypeTranslations,
                accessoryUsageTranslations,
                genderTranslations,
                subcategoryTranslations,
            });
        }
        return Promise.resolve(JSON.parse(cachedResult));
    }
    const response = await Network.get(endpoint, {
        params,
    });
    const result = response.data;
    if (shouldReportAnalytics) {
        setDigitalData(DigitalDataMutation.PLP_VIEW_FILTER_RESULT_BLOOMREACH, {
            searchTerm: categoryId !== q ? q : '',
            facets: analyticsFacets,
            sort,
            accessoryTypeTranslations,
            accessoryUsageTranslations,
            genderTranslations,
            subcategoryTranslations,
        });
    }
    cache.set(cacheKey, JSON.stringify(result));
    setCacheTimeout(cacheKey);
    return result;
}
